<template>
    <div
        v-if="isLoading || (searchStore?.pageData?.results?.length ?? 0) > 0"
        class="UniversityCards"
    >
        <template
            v-for="(item, index) in universities"
            :key="itemKey(item, index)"
        >
            <OrganisationCard
                :organisation="item"
                :loading="isLoading"
                :position="index"
                :disciplineName="disciplineName"
            />
        </template>
    <Pagination />
	<Faqs />
    </div>
</template>

<script setup lang="ts">
import { SearchResultItem } from "@app/ad-manager/utils/banner-positions";
import IPersonalizedOrganisationCard from "@shared/interfaces/dtos/IPersonalizedOrganisationCard";
import OrganisationCard from './OrganisationCard/OrganisationCard.vue';
import { useSearchStore } from "@stores/useSearchStore";
import { disciplineGetSubOrParentDiscipline } from "@studyportals/static-domain-data/disciplines/discipline-get-sub-or-parent-discipline";
import { computed } from "vue";
import Pagination from '../Pagination/Pagination.vue';
import Faqs from '../Faqs/Faqs.vue';

const skeletonCardCount = 20;
const searchStore = useSearchStore();

const universities = computed<(IPersonalizedOrganisationCard | undefined)[]>(() => {
	if (searchStore.loading || !searchStore.pageData?.results) {
		return Array.from({ length: skeletonCardCount }, () => undefined);
	}

	return searchStore.pageData.results;
});


const itemKey = (item: SearchResultItem<IPersonalizedOrganisationCard | undefined>, index: number): string => {
	const organisation = item as IPersonalizedOrganisationCard | undefined;
	return `organisation-${organisation?.id ?? `skeleton-organisation-${index}`}`;
};

const isLoading = computed(() => searchStore.loading);

const disciplineName = computed(() => {
    if (!searchStore.pageData?.context?.rankedDisciplineId) {
        return undefined;
    }

	const discipline = disciplineGetSubOrParentDiscipline(searchStore.pageData?.context?.rankedDisciplineId ?? '');

	return discipline?.name ?? undefined;
});

</script>

<style scoped lang="scss">

    .UniversityCards {
        display: flex;
		flex-direction: column;
		gap: 1rem;
    }

    .Title {
        color: $Grey-900;
        @include TextStyle(HeadingSmall);

        @include Breakpoint(Large, ExtraLarge) {
            @include TextStyle(HeadingMedium);
        }
    }
</style>
